import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';

import { CoacheeMoodDialogController } from 'dialog/coachee-mood-dialog/coachee-mood-dialog.controller';
import { CoacheeMoodDialogStore } from 'dialog/coachee-mood-dialog/coachee-mood-dialog.store';

@Component({
	selector: 'spr-coachee-mood-dialog',
	templateUrl: './coachee-mood-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoacheeMoodDialogStore, CoacheeMoodDialogController],
	host: {
		class: 'flex flex-col items-stretch space-y-3',
	},
})
export class CoacheeMoodDialogComponent {
	public form: FormGroup;
	public moodOptions: SelectItem[];
	public formValid$: Observable<boolean>;
	public frequencyOptions$: Observable<SelectItem[]>;

	constructor(
		private _controller: CoacheeMoodDialogController,
		private _dialogRef: DynamicDialogRef
	) {
		this.moodOptions = [
			{ icon: 'fas fa-bolt', label: '', value: 0, styleClass: 'text-4xl' },
			{
				icon: 'fas fa-cloud-showers-heavy',
				label: '',
				value: 1,
				styleClass: 'text-4xl',
			},
			{ icon: 'fas fa-cloud', label: '', value: 2, styleClass: 'text-4xl' },
			{ icon: 'fas fa-cloud-sun', label: '', value: 3, styleClass: 'text-4xl' },
			{ icon: 'fas fa-sun', label: '', value: 4, styleClass: 'text-4xl' },
		];
		this.frequencyOptions$ = this._controller.frequencyOptions$;
		this.formValid$ = this._controller.selectValid();
		this.form = _controller.form;
	}

	public onSaveClick() {
		this._controller.saveMood().subscribe(() => this._dialogRef.close());
	}
}
